import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import { TestimonialData } from '../types';

const Testimonials: React.FC = () => {
  const testimonials: TestimonialData[] = [
  {
    id: '1',
    name: 'Sarah Mitchell',
    role: 'CTO',
    company: 'TechVentures Inc',
    content: 'The custom API integration transformed our operations completely. What used to take our team 40 hours weekly now happens automatically. The technical expertise and attention to security details were exceptional.',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1a57c74dc-1763294365205.png",
    alt: 'Professional woman with short brown hair wearing glasses and navy blazer in modern office',
    rating: 5
  },
  {
    id: '2',
    name: 'Michael Chen',
    role: 'VP of Operations',
    company: 'Global Retail Solutions',
    content: 'We needed to integrate 8 different platforms with our legacy ERP system. Make Mind delivered a robust solution that handles millions of transactions daily without a single failure. Outstanding work.',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_10ddd37f7-1763301351016.png",
    alt: 'Asian businessman in gray suit smiling confidently in corporate office setting',
    rating: 5
  },
  {
    id: '3',
    name: 'Emily Rodriguez',
    role: 'Director of IT',
    company: 'HealthCare Innovations',
    content: 'HIPAA compliance was our biggest concern. The team not only met all security requirements but exceeded them. The integration is seamless and our data flows securely across all systems.',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1970ad89d-1763296763905.png",
    alt: 'Hispanic woman with long dark hair in white medical coat standing in healthcare facility',
    rating: 5
  }];


  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-text-primary mb-4">
            What Technical Leaders Say
          </h2>
          <p className="text-lg text-text-secondary">
            Trusted by CTOs and technical decision-makers worldwide
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((testimonial) =>
          <div
            key={testimonial.id}
            className="bg-card p-6 rounded-lg border border-border hover:shadow-lg transition-all duration-fast">

              <div className="flex items-center space-x-1 mb-4">
                {[...Array(testimonial.rating)].map((_, index) =>
              <Icon key={index} name="Star" size={16} className="text-warning fill-warning" />
              )}
              </div>
              
              <p className="text-text-secondary mb-6 leading-relaxed">
                "{testimonial.content}"
              </p>
              
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-primary flex-shrink-0">
                  <Image
                  src={testimonial.avatar}
                  alt={testimonial.alt}
                  className="w-full h-full object-cover" />

                </div>
                <div>
                  <div className="font-semibold text-text-primary">
                    {testimonial.name}
                  </div>
                  <div className="text-sm text-text-secondary">
                    {testimonial.role}, {testimonial.company}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>);

};

export default Testimonials;